import React from "react";
import FormActions from "../../../components/Form/FormActions";

interface BordasFormProps {
  nome: string;
  isSaving: boolean;
  onSubmit: (event: React.FormEvent<HTMLFormElement>) => void;
  onCancel: () => void;
  onNomeChange: (nome: string) => void;
}

const BordasForm: React.FC<BordasFormProps> = ({
  nome,
  isSaving,
  onSubmit,
  onCancel,
  onNomeChange,
}) => {
  return (
    <form onSubmit={onSubmit} className="space-y-4">
      <div>
        <label className="mb-1 block text-sm font-medium text-neutral-700">
          Nome da borda
        </label>
        <input
          type="text"
          value={nome}
          onChange={(event) => onNomeChange(event.target.value)}
          className="w-full rounded-md border border-neutral-300 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-primary"
          placeholder="Ex: Catupiry"
        />
      </div>

      <FormActions onCancel={onCancel} isLoading={isSaving} />
    </form>
  );
};

export default BordasForm;
